export function handleNavigate(options, isTo = false) {
  let url = ''
  const { targetType, targetAddr, courseType, targetAddrType } = options
  if (!targetType || targetType === 99) return 'javascript:;'
  if (targetType === 1) {
    const functionEnum = {
      1: '/',
      2: '/course/list',
      3: '/grade/list',
      4: '/teacher/list',
      5: '/article/list',
      6: '/account/info',
      7: '/paper/list'
    }
    if (functionEnum[targetAddr]) {
      url = functionEnum[targetAddr]
    } else {
      url = '/'
    }
  }
  // 资源
  if (targetType === 2) {
    if (targetAddr) {
      if (courseType || targetAddrType) {
        const type = courseType || targetAddrType
        // (1:直播、2:视频、3:音频、4:图文、5:专题、6:套餐 )
        const typeObj = {
          1: 'live',
          2: 'video',
          3: 'audio',
          4: 'graphic',
          5: 'subject',
          6: 'topic',
          14: 'single'
        }
        if (type) {
          url = `/course/${typeObj[type]}?id=${targetAddr}`
        }
      }
    } else {
      url = '/course/list'
    }
  }

  if ([3, 5, 8, 10].includes(targetType)) {
    // 3.资源分类,5.班级分类,8.资讯分类,10.试卷分类
    const targetEnum = {
      3: '/course/list',
      5: '/grade/list',
      8: '/article/list',
      10: '/paper/list'
    }
    if (targetEnum[targetType]) {
      url = `${targetEnum[targetType]}?categoryId=${targetAddr}`
    } else {
      url = '/'
    }
  }

  if ([4, 6, 7].includes(targetType)) {
    // 4.班级，6.教师，7.资讯
    const targetEnum = { 4: 'grade', 6: 'teacher', 7: 'article' }
    if (targetAddr) {
      url = `/${targetEnum[targetType]}/view?id=${targetAddr}`
    } else {
      url = `/${targetEnum[targetType]}/list`
    }
  }
  // 自定义链接
  if (targetType === 90) {
    if (targetAddr) {
      url = targetAddr
    }
  }
  if (isTo) {
    return navigateTo(url)
  } else {
    return url
  }
}

// 获取url中的参数
export function getUrlParam(path, name) {
  const reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
  if (reg.test(path)) { return unescape(RegExp.$2.replace(/\+/g, ' ')) }
  return ''
}
//蛇形命名转换为驼峰命名法（camelCase）
export function snakeToCamel(snakeStr) {
  return snakeStr
    .toLowerCase()
    .split("_")
    .map((word, index) => {
      return index > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word;
    })
    .join("");
};

// 验证是否为blob格式
export function blobValidate(data) {
  return data.type !== 'application/json'
}

/**
 * 导航展示名：历史「入学测试」统一显示为「申硕基点诊断」
 */
export function displayNavName(navItem) {
  if (!navItem) return ''
  const name = String(navItem.navName || '').trim()
  const path = String(navItem.path || handleNavigate(navItem) || '')
  if (name === '入学测试' || path.indexOf('/entrancetest') === 0) {
    return '申硕基点诊断'
  }
  return name || ''
}

// 通用下载方法
export function download(data, filename) {
  const isBlob = blobValidate(data);
  if (isBlob) {
    const blob = new Blob([data])
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}